import React, { useState, useEffect } from "react";
import "./Dashboard.scss";
import { Container, Row, Col } from "react-bootstrap";
import QuickActions from "./QuickActions";
import BirthdaySlider from "./BirthdaySlider";
import Holidays from "./Holidays";
import QuickLinks from "./QuickLinks";
import { Link } from "react-router-dom";
import { config } from "../../App";
import axios from "axios";

const Dashboard = ({ appAccessForUser }) => {

  const userName = sessionStorage.getItem("username");
  const token = sessionStorage.getItem("token");

  const [announcements, setAnnouncements] = useState([]);
  const [announcementsLoaded, setAnnouncementsLoaded] = useState(false);

  const getAnnouncements = async () => {
    try {
      //"https://sgentdev.spicejet.com/devessapi/api/home/getannouncements/"
      const response = await axios.get(
        `${config.endpoint}/home/getannouncements`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = response?.data;
      if (data?.status && Array.isArray(data.Data) && data.Data.length > 0) {
        setAnnouncements(data.Data);
      }
    } catch (err) {
      console.error("Announcements fetch error:", err);
    } finally {
      setAnnouncementsLoaded(true);
    }
  };

  useEffect(() => {
    getAnnouncements();
  }, []);

  return (
    <section className="px-4">
      <Container fluid>

        {/* ===== First Row ===== */}

        <Row>
          <Col xl={8} lg={8} md={12} className="mb-4">
            <div className="firstSection">
              <Row>
                <Col xl={4} lg={4} md={12}>
                  <h2>
                    Hello <span>{userName}</span>
                    <span>
                      <img src="/images/icon/hey-icon.png" className="img-fluid" alt="" />
                    </span>
                  </h2>

                  <p>
                    Easily access and manage all your payroll, reimbursements,
                    and IT computations in one place.
                  </p>
                </Col>

                <Col xl={8} lg={8} md={12} className="mt-5 pt-5 mt-lg-0 pt-lg-0">
                  <ul className="internalLink">

                    <li>
                      <div class="card payslip-card text-center p-4 position-relative">

                        <div class="icon-circle bg-pink">
                          <img src="/images/icon/payslip-icon.svg" className="img-fluid" />
                        </div>

                        <h4 className="fw-bold mt-5 mb-2">PaySlip</h4>
                        <p className="text-muted mb-4">Download salary slips</p>

                        <Link to={`/paySlip`} className="btn btn-danger rounded-pill px-4">
                          View Payslips <span className="ms-3"><img src="/images/icon/arrow-icon.svg" className="img-fluid" /></span>
                        </Link>

                      </div>
                    </li>

                    <li>
                      <div className="card payslip-card text-center p-4 position-relative">

                        <div className="icon-circle bg-orange">
                          <img src="/images/icon/form-16.svg" className="img-fluid" />
                        </div>

                        <h4 className="fw-bold mt-5 mb-2">Form 16</h4>
                        <p className="text-muted mb-4">Download Tax Certificate</p>

                        <Link to={`/form16`} className="btn btn-warning text-white rounded-pill px-4">
                          View Form 16 <span className="ms-3"><img src="/images/icon/arrow-icon.svg" className="img-fluid" /></span>
                        </Link>

                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl={4} lg={4} md={12} className="mb-4">
            <div className="announcement-box p-4">

              <h4 className="title mb-4">Latest Announcements</h4>

              {announcementsLoaded && announcements?.length > 0 ? (
                <div id="announcementSlider" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {announcements.map((item, index) => (
                      <div
                        key={item.AnnouncementID}
                        className={`carousel-item ${index === 0 ? "active" : ""}`}
                      >
                        <div className="announcement-card">
                          <div className="top">
                            <h6>{item.Title}</h6>
                          </div>
                          <div className="line"></div>
                          <div
                            className="custom_scrollbar"
                            dangerouslySetInnerHTML={{ __html: item.HtmlContent }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  {announcements.length > 1 && (
                    <div className="carousel-indicators">
                      {announcements.map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          data-bs-target="#announcementSlider"
                          data-bs-slide-to={index}
                          className={index === 0 ? "active" : ""}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center pt-2 w-50 m-auto announcementsImg">
                  <img src="./images/icon/announcements.png" className="img-fluid" />
                </div>
              )}
            </div>
          </Col>
        </Row>

        {/* ===== Second Row ===== */}
        <QuickActions />

        <Row>
          <Col xl={4} lg={4} md={6} className="mb-5">
            <BirthdaySlider />
          </Col>

          <Col xl={4} lg={4} md={6} className="mb-5">
            <Holidays />
          </Col>

          <Col xl={4} lg={4} md={6} className="mb-5">
            <QuickLinks />
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default Dashboard;
